import { timestampToDateString } from './timestamp';

/** int64 no protobuf JS pode vir como string. */
function protoInt64(value) {
    if (value == null || value === '') {
        return 0;
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === 'string') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }
    if (typeof value === 'object' && typeof value.toString === 'function') {
        const parsed = Number(value.toString());
        return Number.isFinite(parsed) ? parsed : 0;
    }
    return 0;
}

function countAmount(msg) {
    if (!msg) {
        return { total: 0, total_amount: 0 };
    }
    return {
        total: msg.getTotal() || 0,
        total_amount: protoInt64(msg.getTotalAmount()),
    };
}

function jobsSummary(msg) {
    if (!msg) {
        return {
            total: 0,
            total_objects: 0,
            in_progress: 0,
            completed: 0,
            issues: 0,
            total_duration_minutes: 0,
            total_filament_grams: 0,
            total_printed_objects: 0,
            success_rate_objects: 0,
            top_printer: null,
        };
    }
    const top = msg.getTopPrinter?.();
    return {
        total: msg.getTotal() || 0,
        total_objects: msg.getTotalObjects() || 0,
        in_progress: msg.getInProgress() || 0,
        completed: msg.getCompleted() || 0,
        issues: msg.getIssues() || 0,
        total_duration_minutes: msg.getTotalDurationMinutes() || 0,
        total_filament_grams: msg.getTotalFilamentGrams() || 0,
        total_printed_objects: msg.getTotalPrintedObjects() || 0,
        success_rate_objects: msg.getSuccessRateObjects() || 0,
        top_printer: top ? {
            printer_uuid: top.getPrinterUuid() || '',
            name: top.getName() || '',
            total_duration_minutes: top.getTotalDurationMinutes() || 0,
            duration_share_percent: top.getDurationSharePercent() || 0,
            total_jobs: top.getTotalJobs() || 0,
        } : null,
    };
}

function ordersAmount(msg) {
    if (!msg) {
        return {
            total_amount: 0,
            cash_amount: 0,
            pix_amount: 0,
            credit_card_amount: 0,
            debit_card_amount: 0,
            bank_transfer_amount: 0,
            barter_amount: 0,
            pending_payment: 0,
        };
    }
    return {
        total_amount: protoInt64(msg.getTotalAmount()),
        cash_amount: protoInt64(msg.getCashAmount()),
        pix_amount: protoInt64(msg.getPixAmount()),
        credit_card_amount: protoInt64(msg.getCreditCardAmount()),
        debit_card_amount: protoInt64(msg.getDebitCardAmount()),
        bank_transfer_amount: protoInt64(msg.getBankTransferAmount()),
        barter_amount: protoInt64(msg.getBarterAmount()),
        pending_payment: protoInt64(msg.getPendingPayment()),
    };
}

function salesByChannel(msg) {
    if (!msg) {
        return { channels: [] };
    }
    return {
        channels: (msg.getChannelsList?.() || [])
            .map((row) => ({
                name: row.getName?.() || '',
                amount: protoInt64(row.getAmount?.()),
            }))
            .filter((row) => row.name),
    };
}

function salesByDay(msg) {
    if (!msg) {
        return { sales: [] };
    }
    return {
        sales: (msg.getSalesList() || [])
            .map((row) => ({
                date: timestampToDateString(row.getDate()),
                amount: protoInt64(row.getAmount()),
            }))
            .filter((row) => row.date),
    };
}

function transactionsSummary(msg) {
    if (!msg) {
        return {
            total_income: 0,
            total_outcome: 0,
            net_amount: 0,
            total_transactions: 0,
        };
    }
    return {
        total_income: protoInt64(msg.getTotalIncome()),
        total_outcome: protoInt64(msg.getTotalOutcome()),
        net_amount: protoInt64(msg.getNetAmount()),
        total_transactions: msg.getTotalTransactions() || 0,
    };
}

/** Converte DashboardData (proto) para o shape usado pelo DashboardPage. */
export function dashboardDataFromProto(data) {
    if (!data) {
        return null;
    }

    return {
        printers_totals: countAmount(data.getPrintersTotals()),
        materials_total: countAmount(data.getMaterialsTotal()),
        products_total: data.getProductsTotal() || 0,
        checkouts_total: data.getCheckoutsTotal() || 0,
        orders_total: data.getOrdersTotal() || 0,
        quotes_total: typeof data.getQuotesTotal === 'function' ? (data.getQuotesTotal() || 0) : 0,
        jobs_summary: jobsSummary(data.getJobsSummary()),
        orders_amount: ordersAmount(data.getOrdersAmount()),
        checkouts_amount: protoInt64(data.getCheckoutsAmount()),
        sales_by_channel_amount: salesByChannel(data.getSalesByChannelAmount()),
        sales_by_day_amount: salesByDay(data.getSalesByDayAmount()),
        customers_total: data.getCustomersTotal() || 0,
        transactions_summary: transactionsSummary(data.getTransactionsSummary()),
        replacement_parts_total: countAmount(data.getReplacementPartsTotal?.()),
        maintenances_total: data.getMaintenancesTotal?.() || 0,
        operational_costs_month_total: typeof data.getOperationalCostsMonthTotal === 'function'
            ? protoInt64(data.getOperationalCostsMonthTotal())
            : 0,
    };
}
